import { configureStore } from "@reduxjs/toolkit";
import dataReducer from "../features/data/data.slice";
import investVehicleReducer from "../features/investVehicle.slice";
import stepperReducer from "../features/stepper.slice";
import submitionReducer from "../features/submition/submition.slice";
import fileUploadReducer from "../features/fileUpload/fileUpload.slice";
import notificationReducer from "../features/notification/notification.slice";
import ratingReducer from "../features/rating/rating.slice";
import speakToAConsultantReducer from "../features/speakToAConsultant/speakToAConsultant.slice";
import alertReducer from "../features/alert/alert.slice";
import formStepperReducer from "../features/formStepper.slice";
import userReducer from "../features/user/user.slice";

import { StateLoader } from "./stateLoader";

export const store = configureStore({
  reducer: {
    stepper: stepperReducer,
    investVehicle: investVehicleReducer,
    data: dataReducer,
    submition: submitionReducer,
    fileUpload: fileUploadReducer,
    notification: notificationReducer,
    rating: ratingReducer,
    speakToAConsultant: speakToAConsultantReducer,
    alert: alertReducer,
    formStepper: formStepperReducer,
    user: userReducer,
  },
  preloadedState: StateLoader.loadState(),
});

store.subscribe(() => {
  StateLoader.saveState(store.getState());
});
